export const calculationRelevantFahrerFields = [
  'meta.bezugZumVn',
  'anredeId',
  'geburtsdatum',
  'fuehrerscheindatum',
  'meta.isFullAge',
  'meta.inHaeuslicherGemeinschaftMitVN',
  'meta.hasAnBegleitetenFahrenTeilgenommen',
  'meta.hasPunkteInFlensburg',
  'familienstand',
  'nationalitaet',
  'meta.berufsstatus',
  'beruf',
  'meta.speziellerArbeitgeber',
  'meta.tarifgruppe',
  'meta.hasMinderjaehrigeKinder',
  'meta.hasAnSicherheitstrainingTeilgenommen',
  'meta.hasPunkteInFlensburg',
  'meta.isMitarbeiterAutohersteller',
  'meta.hasJahreskarteOeffentlicherPersonenverkehr',
  'meta.jahreskarteOeffentlicherPersonenverkehr.bahnNormal',
  'meta.jahreskarteOeffentlicherPersonenverkehr.bahnComfort',
  'meta.jahreskarteOeffentlicherPersonenverkehr.sonstige',
  'meta.hasWohneigentum',
  'meta.wohneigentum.typ',
  'meta.wohneigentum.gesellschaftID',
  'meta.wohneigentum.isVermietet',
  'meta.isHauptnutzer',
];
